import axios, { AxiosResponse } from 'axios';

import UpdateTestTypeInput from 'modules/Global/models/UpdateTestTypeInput';

export default function updateAsync(apiUrl: string) {
  return function api<TResponse>(
    id: string | undefined | null,
    input: UpdateTestTypeInput | undefined | null
  ): Promise<AxiosResponse<TResponse>> {
    return new Promise<AxiosResponse<TResponse>>((resolve, reject) => {
      axios
        .request<TResponse>({
          url: `${apiUrl}/api/app/test-type-definitions/${id}`,
          method: 'PUT',
          data: input,
        })
        .then(response => {
          if (response.status === 400) {
            reject(response);
            return;
          }
          resolve(response);
        }, reject);
    });
  };
}
